import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { REGEX_GTM_CONTAINER_ID } from './regex';

/* The backend trims and upper-cases before storing, so " gtm-abc1234 " is valid and lands as
   GTM-ABC1234. Normalizing here keeps the client check and the stored value in agreement. */
export function normalizeGtmContainerId(value: unknown): string | null {
  const normalized = typeof value === 'string' ? value.trim().toUpperCase() : '';
  return normalized || null;
}

export function gtmContainerIdValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const containerId = normalizeGtmContainerId(control.value);

    if (!containerId) {
      return null;
    }

    return REGEX_GTM_CONTAINER_ID.test(containerId) ? null : { invalidGtmContainerId: true };
  };
}
